<template>
  <div class="glow-container">
    <img src="/icons/glow.svg" class="glow" />
  </div>
</template>

<style scoped lang="scss">
.glow-container {
  position: absolute;
  z-index: -1;
  width: 100%;
}
.glow {
  position: absolute;
  z-index: -1;
}
@media (--vs) {
  .glow-container {
    width: 100vw;
    height: 100vh;

    overflow-x: hidden;
    overflow-y: visible;
    .glow {
      max-width: unset;
      width: 200vw;
      left: -50%;
    }
  }
}
</style>
